import { IconSearchStroked } from '@consta/icons/IconSearchStroked'
import { Button } from '@consta/uikit/Button'
import { FieldGroup } from '@consta/uikit/FieldGroup'
import { Text } from '@consta/uikit/Text'
import { TextField } from '@consta/uikit/TextField'
import { selectActiveProjectName, useAppSelector } from '@core/core/store'
import { getProjectNameCustomParams, getStringFromNumbersLettersOnly } from '@core/core/utils'
import { useSpa } from '@core/hooks'
import type { Nullable } from 'common/types'
import type { FC, KeyboardEvent } from 'react'
import { useState } from 'react'

import css from './NewImportFromLocalFilesSelector.css'
import type { NewImportFromDBSelectorProps as Props } from './types'

export const NewImportFromDBSelector: FC<Props> = ({ onSelect, globalSearch }) => {
  const activeProjectName = useAppSelector(selectActiveProjectName)
  const sendSpaEvent = useSpa()
  const [searchQuery, setSearchQuery] = useState<string>(globalSearch ?? '')
  const disabledSearchBtn = searchQuery.length < 2

  const onGlobalSearchChange = (value: Nullable<string>) => {
    setSearchQuery(getStringFromNumbersLettersOnly(value))
  }

  const handleTextFieldKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && activeProjectName) {
      onSelect('alldb', searchQuery)
      sendSpaEvent('new import_search', [
        { name: 'project_name', type: 'STRING', value: activeProjectName },
      ])
    }
  }

  return (
    <div className={css.container}>
      <Text size="m" view="secondary" weight="regular" as="span" className={css.searchText}>
        Поиск
      </Text>
      <FieldGroup size="s" className={css.globalSearchContainer}>
        <TextField
          data-testid="globalSearch"
          id="globalSearch"
          placeholder="Найти по базам данных проекты, месторождения, скважины через пробел"
          className={css.globalSearchField}
          value={searchQuery}
          leftSide={IconSearchStroked}
          withClearButton={true}
          onChange={onGlobalSearchChange}
          onKeyDown={handleTextFieldKeyDown}
        />
        <Button
          view="primary"
          label="Найти"
          className={css.findBtn}
          data-analytics-id="new import_search"
          data-analytic-params={getProjectNameCustomParams(activeProjectName)}
          disabled={disabledSearchBtn}
          onClick={() => {
            onSelect('alldb', searchQuery)
          }}
        />
      </FieldGroup>
    </div>
  )
}
